<template>
    <section class="onboarding-de onboarding-type-a">
        <div class="container">
            <form id="onboarding-de" class="wrapper wrapper-tab-last" role="form" method="post" @submit.prevent="submit" novalidate>                
                <header>
                    <strong class="new-headline-md text-centered">Bitte beantworten Sie 2 einfache Fragen, vielen Dank.</strong>
                
                    <div v-if="success" class="new-text-lg text-bold text-centered text-green text-success">
                        <figure>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="12" fill="white"/>
                            <circle cx="12" cy="12" r="12" fill="#00A671" fill-opacity="0.35"/>
                            <path d="M10 14.8125L17.0625 7.71875L18 8.65625L10 16.6562L6.28125 12.9375L7.1875 12L10 14.8125Z" fill="#00A671"/>
                            <path d="M10 14.8125L9.64645 15.1661L10.0008 15.5204L10.3543 15.1653L10 14.8125ZM17.0625 7.71875L17.4161 7.3652L17.0617 7.01086L16.7082 7.36598L17.0625 7.71875ZM18 8.65625L18.3536 9.0098L18.7071 8.65625L18.3536 8.3027L18 8.65625ZM10 16.6562L9.64645 17.0098L10 17.3634L10.3536 17.0098L10 16.6562ZM6.28125 12.9375L5.92176 12.59L5.58008 12.9434L5.9277 13.2911L6.28125 12.9375ZM7.1875 12L7.54105 11.6464L7.18146 11.2868L6.82801 11.6525L7.1875 12ZM10.3543 15.1653L17.4168 8.07152L16.7082 7.36598L9.64567 14.4597L10.3543 15.1653ZM16.7089 8.0723L17.6464 9.0098L18.3536 8.3027L17.4161 7.3652L16.7089 8.0723ZM17.6464 8.3027L9.64645 16.3027L10.3536 17.0098L18.3536 9.0098L17.6464 8.3027ZM10.3536 16.3027L6.6348 12.5839L5.9277 13.2911L9.64645 17.0098L10.3536 16.3027ZM6.64074 13.285L7.54699 12.3475L6.82801 11.6525L5.92176 12.59L6.64074 13.285ZM6.83395 12.3536L9.64645 15.1661L10.3536 14.4589L7.54105 11.6464L6.83395 12.3536Z" fill="#00A671"/>
                            </svg>
                        </figure>
                        <span>Vielen Dank für Ihre Zeit!</span> 
                    </div>
                </header>

                <div class="form-input-radio-button-wrapper" v-if="!success">
                    <div class="form-input-radio-button form-input-radio-button--with-input form-input-radio-button--with-input-only">
                        <div class="form-input-radio-button-inner">
                            <span class="label-static">Was hat Ihnen an Vitadio gut gefallen?</span> 
                        </div> 
                        <div class="form-input-radio-button-form">
                            <form-input-type-text-area 
                                name="liked" 
                                placeholder="Bitte fügen Sie Ihre Antwort ein"
                                :errors="errors.liked"
                                auto-grow 
                                required
                            ></form-input-type-text-area>
                        </div>
                    </div>

                    <div class="form-input-radio-button form-input-radio-button--with-input form-input-radio-button--with-input-only">
                        <div class="form-input-radio-button-inner">
                            <span class="label-static">Welche Funktionen haben Ihnen in der Vitadio-App gefehlt?</span> 
                        </div> 
                        <div class="form-input-radio-button-form">
                            <form-input-type-text-area 
                                name="missing_features" 
                                placeholder="Bitte fügen Sie Ihre Antwort ein"
                                :errors="errors.missing_features"
                                auto-grow 
                                required
                            ></form-input-type-text-area>
                        </div>
                    </div>

                    <v-button label="Senden" type="submit" size="lg" position="center"></v-button>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                choosenSurvey: null,
                success: false,
                token: null,
                errors: {},
            }
        },

        mounted() {
            let uri = new URI(location.href)

            let token = uri.pathname().replace("/web-feedback-form/", "")
            this.token = token
        },

        methods: {
            submit() {
                const formData = new FormData()

                $('#onboarding-de')
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData.append(name, value)
                    })

                formData.append('uuid', this.token)

                axios
                    .post('/api/web-feedback-form', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.success = true
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>